// Load-bearing: this reference is required for `tsc -b` to resolve the `*.svg`
// imports below. The ambient `declare module '*.svg'` in client.d.ts is not
// picked up across the package boundary when @repo/utils is consumed as source,
// so any new .ts file in this package that imports an svg needs the same line.
/// <reference path="../types/client.d.ts" />
import scalerLogo from '../assets/scaler-logo.svg';
import scalerLogoDark from '../assets/scaler-logo-dark.svg';
import scalerLogoSmall from '../assets/scaler-logo-small.svg';
import scalerLogoSmallDark from '../assets/scaler-logo-small-dark.svg';

export const DEFAULT_PRODUCT_NAME = 'Scaler CRM';
export const DEFAULT_COMPANY_NAME = 'Scaler Pvt. Ltd';

export const DEFAULT_BRANDING = {
  logo: scalerLogo,
  logoDark: scalerLogoDark,
  logoSmall: scalerLogoSmall,
  logoSmallDark: scalerLogoSmallDark,
  productName: DEFAULT_PRODUCT_NAME,
  companyName: DEFAULT_COMPANY_NAME,
};
